import { Control, useController } from 'react-hook-form';

import { DateField } from '@limepayments/cosmic';

import { FormInputs } from './types';

interface DateProps {
  id?: string;
  control: Control<FormInputs>;
  name: 'dateOfBirth' | 'passportExpDate';
  label: string;
  defaultValue: string;
  rules?: object;
  type?: string;
  required?: boolean;
  testId?: string;
  placeholder?: string;
  disabled?: boolean;
}

const mask = [/[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];

const Date = (props: DateProps) => {
  const { label, type, required, testId, placeholder, disabled, ...otherProps } = props;
  const {
    field: { ref, ...inputProps },
    fieldState: { error },
  } = useController(otherProps);

  return (
    <DateField
      {...inputProps}
      label={label}
      placeholder={placeholder}
      required={required}
      error={error?.message ?? ''}
      type={type ?? 'text'}
      helperText={error ? error.message : ''}
      testId={testId}
      maskPlaceholder="DD/MM/YYYY"
      mask={mask}
      inputMode="numeric"
      disabled={disabled}
    />
  );
};

export default Date;
